import Moment from 'moment'
import Config from './config'
import { $trackPost, $post } from './http'
import Api from './api'
import Filters from './filters'
import Wx from 'weixin-js-sdk'
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import zhCN from 'video.js/dist/lang/zh-CN.json';
// 使用 addLanguage 注册中文
videojs.addLanguage('zh-CN', zhCN);
export default {
    Attribute: {
        UA: window.navigator.userAgent,
        // 判断是否是微信
        isWeixin() {
            var ua = this.UA
            if (/MicroMessenger/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是QQ
        isQQ() {
            var ua = this.UA
            if (/QQ\//.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是Android
        isAndroid() {
            var ua = this.UA
            if (/android/i.test(ua)) {
                return true
            }
            return false
        }
    },
    // 裁切图片
    slimImg(img, w) {
        if (img) {
            const imgParams = `x-image-process=image/resize,m_fixed,w_${w}/quality,q_80`
            return img.indexOf('?') > -1 ? `${img}&${imgParams}` : `${img}?${imgParams}`
        } else {
            return ''
        }
    },
    // 跳转到对应pc页面
    httpToPc(pathname, lan) {
        if (!/Android|webOS|iPhone|iPod|BlackBerry|Windows Phone|Harmony/i.test(this.Attribute.UA)) {
            let url = lan !== 'en' ? Config.pcDomain : Config.pcEnDomain
            for (const key in Config.pcPage) {
                if (pathname.indexOf(`/${key}`) > -1) {
                    const pcPath = Config.pcPage[key]
                    const pathnameArr = pathname.split('/')
                    const id = pathnameArr.length > 2 ? pathname.split(pathnameArr[1])[1] : ''
                    const expireSignArr = window.location.href.match(/expireSign=([^&]*)(&|$)/)
                    const expireSign = expireSignArr && expireSignArr[1]
                    url = pcPath.indexOf('.html') > -1 ? url.split('/#')[0] : url
                    url = !id ? `${url}/${Config.pcPage[key]}` : `${url}/${Config.pcPage[key]}${id}`
                    expireSign && (url = `${url}?expireSign=${expireSign}`)
                    break
                }
            }
            window.location.href = url
        }
    },
    // 分享
    pageShare() {
        Api.getHomeShare({}).then((data) => {
            data && data.share && this.onshare({
                shareTitle: data.share.shareTitle,
                shareBrief: data.share.shareBrief,
                shareImg: data.share.shareImg,
                shareUrl: window.location.href
            })
        })
    },
    // 判断是不是超链接
    isHyperlinks(url) {
        return /^http(s)?:\/\/(.*)?/.test(url)
    },
    // 分享
    onshare(obj) {
        const shareDate = {
            title: obj.shareTitle,
            desc: obj.shareBrief || obj.shareTitle, // '受理、协助处置网民对互联网违法和不良信息的举报', // obj.shareBrief || obj.shareTitle,
            imgUrl: obj.shareImg,
            link: obj.shareUrl
        }
        // 微信分享
        if (this.Attribute.isWeixin()) {
            this.setWeChatConf().then(() => {
                this.wxOnshare(shareDate)
            })
            // qq分享
        } else if (this.Attribute.isQQ()) {
            if (window.mqq && window.mqq.data && window.mqq.data.setShareInfo) {
                window.mqq.data.setShareInfo({
                    title: shareDate.title,
                    share_url: shareDate.link,
                    image_url: shareDate.imgUrl,
                    desc: shareDate.desc
                })
            } else {
                this.loadjs('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152').then(() => {
                    window.mqq.data.setShareInfo({
                        title: shareDate.title,
                        share_url: shareDate.link,
                        image_url: shareDate.imgUrl,
                        desc: shareDate.desc
                    })
                })
            }
        }
    },
    // 微信配置
    setWeChatConf() {
        return new Promise((resolve, reject) => {
            // Api.getWeChatConf({
            //     url: window.location.href.split('#')[0]
            // }).then(data => {
            $post('https://piyao-api.thecover.cn/wap/counterRumour/weixin/getConf', { url: window.location.href.split('#')[0] }, {}).then(data => {
                const D = data.data
                Wx.config({
                    debug: false,
                    appId: D.appId,
                    timestamp: D.timestamp,
                    nonceStr: D.nonceStr,
                    signature: D.signature,
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'previewImage'
                    ]
                })
                resolve()
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 微信分享
    wxOnshare(obj) {
        Wx.ready(() => {
            // 分享到朋友圈
            Wx.onMenuShareTimeline(obj)
            // 分享给朋友
            Wx.onMenuShareAppMessage(obj)
            // 分享到QQ
            Wx.onMenuShareQQ(obj)
            // 分享到腾讯微博
            Wx.onMenuShareWeibo(obj)
            // 分享到QQ空间
            Wx.onMenuShareQZone(obj)
        })
    },
    // 动态加载js
    loadjs(src) {
        return new Promise((resolve, reject) => {
            const scriptNode = document.createElement('script')
            scriptNode.setAttribute('type', 'text/javascript')
            scriptNode.setAttribute('src', src)
            document.body.appendChild(scriptNode)
            // IE 判断
            if (scriptNode.readyState) {
                scriptNode.onreadystatechange = () => {
                    if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                        resolve()
                    }
                }
            } else {
                scriptNode.onload = () => {
                    resolve()
                }
            }
        })
    },
    // 上拉加载数据
    pullLoadData(fn) {
        const app = document.querySelector('#app')
        app.addEventListener('scroll', () => {
            const winH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            if (app.scrollTop + winH + 10 > app.scrollHeight) {
                fn()
            }
        }, false)
    },
    // 倒计时
    countDown(endTime, serverTime) {
        const nowTime = serverTime ? Moment(serverTime) : Moment()
        const size = Moment.duration(Moment(endTime) - nowTime, 'ms')
        const days = size.get('days')
        const hours = size.get('hours')
        const mins = size.get('minutes')
        const secs = size.get('seconds')
        if (Moment(endTime) - nowTime < 0) {
            return null
        } else {
            return [Filters.number.numToTens(days), Filters.number.numToTens(hours), Filters.number.numToTens(mins), Filters.number.numToTens(secs)]
        }
    },
    // 埋点
    track(type, param) {
        const userInfo = localStorage.getItem('userInfo')
        const userId = (userInfo && JSON.parse(userInfo).userId) || ''
        const deviceId = this.getDeviceId()
        return new Promise((resolve, reject) => {
            $trackPost(Config.trackApiUrl, {
                applicationId: 'sztf_expo', // 必填， 固定值， 后面确定
                eventType: type, // 必填， 枚举。 有load(页面加载), share(分享),click(按钮点击)
                eventTime: new Date().getTime(), // 必填， 时间戳
                activeId: 'sztf_expozkibwscyvqqhwszf', // 必填， 固定值， easy那边最终确定
                distinctId: userId || deviceId, // 必填， 用来关联用户的基本信息，可以游客随机，但是尽量保证一次打开使用同一个而不变，有设备的用设备id， 登录之后用userid。
                uri: window.location.href, // 必填， 页面的URI
                deviceId: deviceId, // 选填.  用来关联APP的设备。
                sessionId: '', // 选填， 尽量保证每次会话不同
                eventParam: param // 具体的参数的值
            }).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    getDeviceId() {
        let did = localStorage.getItem('COVER_KBH_DID')
        if (!did) {
            did = 'other-' + new Date().getTime().toString(36) + '-' + Math.random().toString(36).substr(2, 8)
            localStorage.setItem('COVER_KBH_DID', did)
        }
        return did
    },
    validateInput(val) {
        // 以换行符分隔输入的内容
        const lines = val.split('\n');

        // 遍历每一行，检查是否以'http://'或'https://'开头
        for (let line of lines) {
            if (!line.startsWith('http://') && !line.startsWith('https://')) {
                return false; // 如果有一行不符合条件，返回false
            }
        }
        return true; // 如果所有行都符合条件，返回true
    },
    validateInputText(val) {
        function checkIfEmpty(input) {
            // 去掉字符串两端的空格
            let trimmedInput = input.trim();

            // 检查去掉空格后的字符串是否为空
            if (trimmedInput.length === 0) {
                return true; // 字符串为空
            } else {
                return false; // 字符串不为空
            }
        }
        // 以换行符分隔输入的内容
        const lines = val.split('\n');
        let errList = []
        // 遍历每一行，检查是否以'http://'或'https://'开头
        for (let line of lines) {
            if (!checkIfEmpty(line) && !line.toLowerCase().startsWith('http://') && !line.toLowerCase().startsWith('https://')) {
                errList.push(line); // 如果有一行不符合条件，返回false
            }
        }
        if (errList.length) {
            return `输入网址有误，请确认后重新输入，错误网址为：${errList.join('；')}`
        } else {
            return ''; // 如果所有行都符合条件，返回true
        }
    },
    decodeBase64ToUtf8: function (base64Str) {
        if (!base64Str) {
            return base64Str
        }
        try {
            let normalized = String(base64Str).replace(/[\r\n\s]/g, '').replace(/-/g, '+').replace(/_/g, '/')
            var padding = normalized.length % 4
            if (padding) {
                normalized += '='.repeat(4 - padding)
            }

            var binary = window.atob(normalized)
            if (typeof TextDecoder !== 'undefined') {
                var bytes = Uint8Array.from(binary, ch => ch.charCodeAt(0))
                return new TextDecoder('utf-8').decode(bytes)
            }

            var percentEncoded = Array.prototype.map.call(binary, ch => {
                return '%' + ('00' + ch.charCodeAt(0).toString(16)).slice(-2)
            }).join('')
            return decodeURIComponent(percentEncoded)
        } catch (e) {
            return base64Str
        }
    },
    initContentVideo: function () {
        var _this = this;
        try {
            var videos = $('.details video, .audio-content video, .audio-content video, .video-bief video, .video-details video, .news-content video');
            $.each(videos, function (idx, node) {
                
                if (node.src) {
                    if (node.parentElement && node.parentElement.tagName == 'P') {
                        node.parentElement.style.marginBottom = '0.3rem';
                    }

                    node.className = node.className + ' video-js vjs-default-skin vjs-big-play-centered vjs-progress-holder'
                    var player = videojs(node, {
                        language: 'zh-CN',
                        controls: true,
                        playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
                        sources: [{
                            src: node.src
                        },
                        {
                            src: node.src,
                            type: 'video/mp4'
                        }]
                    })
                    
                    player.ready(function () {

                        var container = player.el();
                        var w = $(container).width()
                        var posterImg = new Image();

                        // 1. 设置海报高度
                        posterImg.onload = function () {
                            container.style.height = (posterImg.height * w / posterImg.width) + 'px';
                        };
                        posterImg.src = player.poster();

                        // 2. 播放时切换到视频高度
                        player.on('play', function () {
                            var video = player.el().querySelector('video');
                            if (video.videoHeight) {
                                container.style.height = (video.videoHeight * w / video.videoWidth) + 'px';
                            } else {
                                player.one('loadedmetadata', function () {
                                    container.style.height = (video.videoHeight * w / video.videoWidth) + 'px';
                                });
                            }
                        });
                    })

                    var tagsInfo = _this.decodeBase64ToUtf8(node.dataset.videoTags)
                    if (tagsInfo !== undefined) {
                        var jsonTags = JSON.parse(tagsInfo)
                        let htmlStr = ''
                        if (jsonTags && jsonTags.videoTagRelateList && jsonTags.videoTagRelateList.length > 0) {
                            var tagList = jsonTags.videoTagRelateList.filter(function (item) {
                                return item.id != -1 && item.tagId != -1
                            })
                            if (tagList.length) {
                                htmlStr = '<div class="video_ai_tag_box">'
                                for (let i = 0; i < tagList.length; i++) {
                                    var tag = tagList[i]
                                    if (i === 0) {
                                        htmlStr += `<div class="ai_tips_box"> <div class="ai_tags_tips">${tag.tagName}</div> ${tagList.length > 1 ? '<div class="ai_tags_arrow"></div>' : ''} </div> <div class="ai_tags_info hide">`
                                    } else {
                                        htmlStr += `<div class="ai_tag">${tag.tagName}</div>`
                                    }
                                }
                                htmlStr += '</div></div>'
                            }
                        }
                        if (htmlStr) {
                            var playerContainer = this.closest('.video-js') || this.parentElement
                            var controlBar = playerContainer ? playerContainer.querySelector('.vjs-control-bar') : null
                            var insertTarget = controlBar ? controlBar.parentElement : null
                            if (insertTarget) {
                                var $insertTarget = $(insertTarget)
                                $insertTarget.find('.video_ai_tag_box').remove()
                                $insertTarget.append(htmlStr)
                            }
                        }
                    }
                }
            });

            $('.video_ai_tag_box').on('click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                const $parentDiv = $(this)
                const $tagsInfo = $parentDiv.find('.ai_tags_info')
                const $tagsArrow = $parentDiv.find('.ai_tags_arrow')
                if (!$tagsInfo.length) {
                    return
                }
                $tagsArrow.css({
                    'transition': 'transform 0.2s ease',
                    'transform-origin': '50% 50%'
                })
                if ($tagsInfo.hasClass('hide')) {
                    $tagsInfo.removeClass('hide')
                    $tagsInfo.css('display', 'block')
                    $tagsArrow.css('transform', 'rotate(180deg)')

                } else {
                    $tagsInfo.addClass('hide')
                    $tagsInfo.css('display', 'none')
                    $tagsArrow.css('transform', 'rotate(0deg)')
                }
                setTimeout(function () {
                    $parentDiv.scrollTop($parentDiv.scrollHeight)
                }, 0)
            })
        } catch (e) { }

    },
}